import React, {useState} from "react";
import styled from "styled-components";
import HamzaJavedImage  from "../../assets/img/hamzaJaved.jpg";
import ChachaImage  from "../../assets/img/chacha.jpg"
export default function Team() {

  // Initial testimonials that will always be there
  const teamData = [
    {
      name: "Asim Jadoon ",
      position: "CEO / CFO", 
      // imageUrl: "https://media.licdn.com/dms/image/v2/C5103AQGhDTkAoLg3mA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1556912979339?e=1763596800&v=beta&t=VoR3Nd2bNldmUn7d7WC69VIGa09kYq-PDeW6ZcBN0cg",
      imageUrl:ChachaImage,
       profileUrl:'https://www.linkedin.com/in/capt-asim-maroof-jadoon-6027534a/',
    },
    {
      name: "Ahmed Junaid",
      position: "Business Director / CTO", 
      imageUrl: "https://media.licdn.com/dms/image/v2/D4D03AQFiawR_pQUNBw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1713367792506?e=1763596800&v=beta&t=X03BV7BhancvXumTw-MB2QtNZMElegAjl284ZGMsGcA",
      profileUrl:'https://www.linkedin.com/in/ahmed-j-624550238/'
    },
    {
      name: "Hamza Sajid Jadoon",
      position: "Senior Manager / Full Stack App Developer", 
      imageUrl: "https://media.licdn.com/dms/image/v2/D4D03AQGvPLUdZE20mw/profile-displayphoto-shrink_800_800/B4DZSh7bDiH0Ac-/0/1737883497286?e=1764806400&v=beta&t=3YjYWjATok0U7wwETd66OLgADbjsbinKwFBacUVAbYk",
      profileUrl:'https://www.linkedin.com/in/hamzasajidjadoon/'
    },
    {
      name: "Maaz Ullah",
      position: "Full Stack App Developer", 
      imageUrl: "https://media.licdn.com/dms/image/v2/D5603AQEyV4Spd1QM2A/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1700810459420?e=1763596800&v=beta&t=xDkylmbzW-LFeEJKBYvWdIXKzFiDaApvnR0zir3WeOU",
      profileUrl:'https://www.linkedin.com/in/maaz-ullah-6724462a1/'
    },
    {
      name: "Hamza Javed",
      position: "Full Stack Web Developer", 
      imageUrl: HamzaJavedImage,
      profileUrl:'https://www.linkedin.com/in/hamza-javed-2606121b9/'
    },
    {
      name: "Muhammad Tehsin ",
      position: "Full Stack Web Developer", 
      imageUrl: "https://media.licdn.com/dms/image/v2/D4D03AQFeLsTnAdy43w/profile-displayphoto-crop_800_800/B4DZkGaWX4H4AQ-/0/1756749195674?e=1763596800&v=beta&t=_4Kcq96FgiKO2iQmL97fDcQQX0SRqMy0DL5E3JuBhCU",
      profileUrl:'https://www.linkedin.com/in/muhammad-tehsin/'
    },
    {
      name: "Sanila Fayas Tehsin ",
      position: "UI/UX Designer", 
      imageUrl: "https://media.licdn.com/dms/image/v2/D4D03AQHPU3mHtblTnw/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1708981214801?e=1763596800&v=beta&t=fOveV01o3EelvnuSgwCy3_Wn4RHSza9A9TqBD8zWcT8",
      profileUrl:'https://www.linkedin.com/in/sanila-fayyaz-2a98a6215/'
    },
  ];

  const handleMemberClick = (profileUrl) => {
   console.log('Clicked');
    //  window.open(profileUrl, '_blank');
  };

  return (
    <Wrapper id="team">
      <div className="lightBg" style={{padding: '50px 0'}}>
        <div className="container">
          <HeaderInfo>
            <div style={{display: 'flex',flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
             <h1 className="font40 extraBold">Our Team</h1>
            </div>
            <p className="font13">
              Meet the talented individuals behind our success. Our diverse team of experts brings together 
              <br />
              years of experience, innovation, and passion to deliver exceptional results for every project.
            </p>
          </HeaderInfo>

          {/* Team Members Horizontal Scroll */}
          <TeamScrollContainer>
            {teamData.map((member, index) => (
              <TeamMemberCard 
                key={index}
                className="animate pointer"
                onClick={() => handleMemberClick(member.profileUrl)}
              >
                <MemberImage src={member.imageUrl} alt={member.name} />
                <MemberName className="font15 extraBold">{member.name}</MemberName>
                <MemberPosition className="font13">
                  {member.position}
                </MemberPosition>
              </TeamMemberCard>
            ))}
          </TeamScrollContainer>
        </div>
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.section`
  width: 100%;
  padding-top: 20px;
`;

const HeaderInfo = styled.div`
  margin-bottom: 50px;
  @media (max-width: 860px) {
    text-align: center;
  }
`;

const TeamScrollContainer = styled.div`
  display: flex;
  gap: 25px;
  overflow-x: auto;
  padding: 20px 10px;
  scroll-behavior: smooth;
  width: 100%;
  
  /* Enable scrolling with mouse wheel and touch */
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  cursor: grab;
  
  &:active {
    cursor: grabbing;
  }
  
  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
  
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;
  scrollbar-width: none;
  
  @media (max-width: 860px) {
    gap: 20px;
    padding: 15px 10px;
  }
`;

const TeamMemberCard = styled.div`
  min-width: 230px;
  height: 250px;
  background: #0B093B;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 25px 15px;
  transition: all 0.3s ease;
  border: 2px solid transparent;
  
  &:hover {
    transform: translateY(-5px);
    border-color: #7620ff;
    box-shadow: 0 10px 25px rgba(118, 32, 255, 0.3);
  }
  
  @media (max-width: 860px) {
    min-width: 180px;
    height: 230px;
    padding: 20px 10px;
  }
`;

const MemberImage = styled.img`
  width: 95px;
  height: 95px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 15px;
  border: 3px solid #7620ff;
`;

const MemberName = styled.h3`
  color: white;
  margin: 0 0 5px 0;
  text-align: center;
  font-size: 16px;
`;

const MemberPosition = styled.p`
  color: #b8b8b8;
  margin: 0;
  text-align: center;
  line-height: 1.4;
`;